<template>
  <TheProfile />
</template>

<script>
import TheProfile from '@/components/Profile/TheProfile.vue'

export default {
  name: 'ProfilePage',

  components: { TheProfile }
}
</script>
